module.exports = __webpack_public_path__ + "img/doc-lock.60dbd3c3.png";